import { Input } from 'antd';
import { localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { FC } from 'react';

interface ApiAccessBulkActionsProps {
    bulkLimit: number | null;
    disabled: boolean;
    translations: Record<string, string>;
    onApplyLimitToAll: () => void;
    onBulkLimitChange: (limit: number | null) => void;
    onDisableAll: () => void;
    onEnableAll: () => void;
}

const sanitizeLimit = (value: string): string => value.replace(/\D/g, '');

const isAllowedLimitKey = (event: React.KeyboardEvent<HTMLInputElement>): boolean => {
    if (event.ctrlKey || event.metaKey) {
        return true;
    }

    return (
        /^\d$/.test(event.key) ||
        [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End',
            'Tab',
        ].includes(event.key)
    );
};

export const ApiAccessBulkActions: FC<ApiAccessBulkActionsProps> = ({
    bulkLimit,
    disabled,
    onApplyLimitToAll,
    onBulkLimitChange,
    onDisableAll,
    onEnableAll,
    translations,
}) => (
    <div className="admin-api-access__bulk-actions">
        <Button
            htmlType="button"
            disabled={disabled}
            onClick={onEnableAll}
        >
            {localize('admin-api-access-enable-all', translations)}
        </Button>
        <Button
            htmlType="button"
            disabled={disabled}
            onClick={onDisableAll}
        >
            {localize('admin-api-access-disable-all', translations)}
        </Button>
        <div className="admin-api-access__bulk-limit">
            <Input
                disabled={disabled}
                inputMode="numeric"
                pattern="[0-9]*"
                value={bulkLimit === null ? '' : String(bulkLimit)}
                placeholder={localize('admin-api-access-limit-placeholder', translations)}
                onKeyDown={(event) => {
                    if (!isAllowedLimitKey(event)) {
                        event.preventDefault();
                    }
                }}
                onChange={(event) => {
                    const value = sanitizeLimit(event.target.value);

                    onBulkLimitChange(value ? Number(value) : null);
                }}
            />
            <Button
                htmlType="button"
                disabled={disabled || bulkLimit === null}
                onClick={onApplyLimitToAll}
            >
                {localize('admin-api-access-apply-limit-all', translations)}
            </Button>
        </div>
    </div>
);